/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useEffect, useState} from 'react'
import ApiKeyTable from './ApiKeyTable'
import {useDispatch, useSelector} from 'react-redux'
import {updateWebhook} from './ApikeysSlices/ApiKeysSlices'
import {
  fetchAsyncUserDetails,
  getAllUserDetails,
  getIsDefaultRegion,
} from '../Overview/OverviewSlice/UserDetailsSlice'
import WebhookTable from './WebhookTable'
import WebhookSecurity from './WebhookSecurity'
import {
  useCreateWebhookSecurityMutation,
  useLazyGetWebhookSecurityQuery,
  useUpdateWebhookSecurityMutation,
} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'
import { useLazyGetUserSettingQuery } from '../../../../../services/cellcast.v3'

const ApiKey = () => {
  const dispatch = useDispatch()
  const userValues = useSelector(getAllUserDetails)
  const [visible, setVisible] = useState<any>(false)
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const [webHookStatus, setWebHookStatus] = useState('')
  const [webHookReceive, setWebHookReceive] = useState('')
  const [webhookOptOut, setWebhookOptOut] = useState('')

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [actionError, setActionError] = useState('')
  const [wbhookSecurityMode, setWebhookSecurityMode] = useState('create')

  const [createWebhookSecurity, createResponse] = useCreateWebhookSecurityMutation()
  const [updateWebhookSecurity, updateResponse] = useUpdateWebhookSecurityMutation()
  const [getWebhookSecurity, getResponse] = useLazyGetWebhookSecurityQuery()
  const [getUserSettingRegion, userSettingRegion] = useLazyGetUserSettingQuery()

  useEffect(() => {
    if (!isDefaultRegion) {
      getUserSettingRegion(null).unwrap().then((res) => {
        res?.data?.webhooks?.forEach((key: any) => {
          key?.type === 'receive' ? setWebHookReceive(key?.url) : setWebHookStatus(key?.url)
        })
      })
    } else {
      userValues?.webHooks?.map((key: any) => {
       if (key?.type === 'receive') {
          setWebHookReceive(key?.url)
        } else if (key?.type === 'status') {
          setWebHookStatus(key?.url)
        } else if (key?.type === 'unsubscribe') {
          setWebhookOptOut(key?.url)
        }
        
      })
    }


    getWebhookSecurity(null).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        }
      } else if ('error' in res) {
        toast.error(res.error?.toString())
      }
    })
  }, [])

  useEffect(() => {
    if (getResponse.data && getResponse.data.data) {
      const username = getResponse.data.data.username || ''
      const password = getResponse.data.data.password || ''

      if (username !== '' && password !== '') {
        setWebhookSecurityMode('update')
      }

      setUsername(username)
      setPassword(password)
    }
  }, [getResponse.data])

  const handleUpdateMo = useCallback(() => {
    dispatch(
      updateWebhook({
        type: 'receive',
        url: webHookReceive,
      })
    ).then(() => {
      dispatch(fetchAsyncUserDetails())
    })
  }, [dispatch, webHookReceive])

  const handleResetMo = useCallback(() => {
    dispatch(
      updateWebhook({
        type: 'receive',
        url: '',
      })
    ).then(() => {
      setWebHookReceive('')
      dispatch(fetchAsyncUserDetails())
    })
  }, [dispatch])

  const handleUpdateDlr = useCallback(() => {
    dispatch(
      updateWebhook({
        type: 'status',
        url: webHookStatus,
      })
    ).then(() => {
      dispatch(fetchAsyncUserDetails())
    })
  }, [dispatch, webHookStatus])

  const handleResetDlr = useCallback(() => {
    dispatch(
      updateWebhook({
        type: 'status',
        url: '',
      })
    ).then(() => {
      setWebHookStatus('')
      dispatch(fetchAsyncUserDetails())
    })
  }, [dispatch])
  const handleUpdateOptOut = useCallback(() => {
    dispatch(
      updateWebhook({
        type: 'unsubscribe',
        url: webhookOptOut,
      })
    ).then(() => {
      dispatch(fetchAsyncUserDetails())
    })
  }, [dispatch, webhookOptOut])

  const handleResetOptOut = useCallback(() => {
    dispatch(
      updateWebhook({
        type: 'unsubscribe',
        url: '',
      })
    ).then(() => {
      setWebhookOptOut('')
      dispatch(fetchAsyncUserDetails())
    })
  }, [dispatch])

  const handleSaveWebhook = useCallback(() => {
    let saveFn = createWebhookSecurity
    if (wbhookSecurityMode === 'update') {
      saveFn = updateWebhookSecurity
    }

    setActionError('')
    saveFn({username, password}).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          setActionError(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
          getWebhookSecurity(null).then((res) => {
            if ('data' in res) {
              if (res.data?.error && Object.keys(res.data?.error).length > 0) {
                toast.error(res?.data?.message)
              }
            } else if ('error' in res) {
              toast.error(res.error?.toString())
            }
          })
        }
      } else if ('error' in res) {
        const resError = res.error as any
        if (resError.data?.message) {
          setActionError(resError.data?.message || '')
        } else {
          setActionError(res?.error.toString() || '')
        }
      }
    })
  }, [password, username])

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer d-flex justify-content-between'
          role='button'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 fs-2'>API Overview</h3>
          </div>
        </div>
        <div className='card-body border-top'>
          <div className='row gx-9 gy-6'>
            <div className='col-xl-6'>
              <div
                className='card  h-xl-100 align-items-start   justify-content-start flex-wrap p-6'
                style={{
                  gap: '30px',
                }}
              >
                <div className='d-flex flex-column py-2'>
                  <div className='d-flex align-items-center fs-4 fw-bolder mb-5'>
                    How to set up API connections
                  </div>
                  <div className='d-flex align-items-center'>
                    <div>
                      <div className='fs-7 fw-light text-gray-600'>
                        Seamlessly integrate SMS to your workflow <br />
                        Setting up your API connection is as simple as creating a new API key. <br />
                        Here's how : <br />
                        <a className='fw-bolder' href='https://developer.cellcast.com/getting-started/api-key.html' target='_blank' rel='noreferrer'>
                          API Set up
                        </a>   
                      </div>
                    </div>
                  </div>
                </div>
                <div className='d-flex align-items-center py-2'>
                  <button
                    data-testid='btnNewAPIKey'
                    onClick={() => {
                      setVisible(true)
                    }}
                    className='btn btn-sm btn-primary btn-active-light-primary text-white me-3'
                  >
                    New API Key
                  </button>
                </div>
              </div>
            </div>

            <div className='col-xl-6'>
              <div
                className='card  h-xl-100 align-items-start   justify-content-start flex-wrap p-6'
                style={{
                  gap: '30px',
                }}
              >
                <div className='d-flex flex-column py-2'>
                  <div className='d-flex align-items-center fs-4 fw-bolder mb-5'>
                    How to set up a Webhook
                  </div>
                  <div className='d-flex align-items-center'>
                    <div>
                      <div className='fs-7 fw-light text-gray-600'>
                        You can use webhooks to receive replies and message delivery status.
                        The webhook URL must accept POST requests and data will be sent in the
                        request body <br /> <br />
                        <b>Receive Webhook:</b> Used to receive replies from users. <br />
                        <b>Status Webhook:</b> Used to receive status updates for sent messages.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <WebhookTable
          username={username || ''}
          password={password || ''}
          moWebhookUrl={webHookReceive}
          setMoWebhookUrl={setWebHookReceive}
          handleUpdateMo={handleUpdateMo}
          handleResetMo={handleResetMo}
          dlrWebhookUrl={webHookStatus}
          setDlrWebhookUrl={setWebHookStatus}
          handleUpdateDlr={handleUpdateDlr}
          handleResetDlr={handleResetDlr}
          handleUpdateOptOut={handleUpdateOptOut}
          handleResetOptOut={handleResetOptOut}
          optOutWebhookUrl={webhookOptOut}
          setOptOutWebhookUrl={setWebhookOptOut}
        />
      </div>
      {isDefaultRegion && (
        <div>
          <WebhookSecurity
            error={actionError}
            username={username}
            fetchLoading={getResponse.isLoading || getResponse.isFetching}
            writeLoading={createResponse.isLoading || updateResponse.isLoading}
            setUsername={setUsername}
            password={password}
            setPassword={setPassword}
            handleSubmit={handleSaveWebhook}
          />
        </div>
      )}
      <div>
        <ApiKeyTable visible={visible} setVisible={setVisible} />
      </div>
    </>
  )
}

export default ApiKey
